import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {
  ManageCegViewMode,
  ManageTableDataConfig,
  ManageTableViewConfig, TableConfigDialog
} from '@manage-ceg/types/manage-ceg-page.types';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { createDeepCopy } from '@shared/utils/common.utils';
import { CustomAvailableBudgetTableConfigDialogComponent } from '@manage-ceg/dialogs/custom-available-budget-table-config-dialog/custom-available-budget-table-config-dialog.component';
import { UtilityService } from '@shared/services/utility.service';
import { BudgetDataService } from '../../../dashboard/budget-data/budget-data.service';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'table-configuration',
  templateUrl: './table-configuration.component.html',
  styleUrls: ['./table-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableConfigurationComponent implements OnInit, OnDestroy {
  private readonly dialog = inject(MatDialog);
  private budgetDataService = inject(BudgetDataService);
  private _tableConfig: ManageTableDataConfig;
  private destroy$ = new Subject<void>();
  @ViewChild('configBtn', { read: ElementRef, static: true }) configBtn: ElementRef;

  @Input() viewMode: ManageCegViewMode;
  @Input() tableConfig: ManageTableDataConfig;
  @Input() isForecastSmartCell: boolean = false;
  @Output() onTableConfigChange = new EventEmitter<ManageTableViewConfig>();

  private budgetId: string;
  private companyId: string;

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.budgetDataService.selectedBudgetBehavior$.pipe(
      filter(budget => !!budget),
      takeUntil(this.destroy$)
    ).subscribe(data => {
      this.companyId = data.company.toString();
      this.budgetId = data.id.toString();
    });
  }

  private onHandleCancel(): void {
    this.tableConfig = this._tableConfig;
  }
  
  private utilityService = inject(UtilityService);
  public isCABEnabled = true;

  showConfigDialog(): void {
    this._tableConfig = createDeepCopy(this.tableConfig);
    const dialogData: TableConfigDialog = {
      budgetId: this.budgetId,
      companyId: this.companyId,
      viewMode: this.viewMode,
      config: this.tableConfig,
      isForecastSmartCell: this.isForecastSmartCell,
      onSubmit: (config: ManageTableViewConfig) => this.onTableConfigChange.emit(config),
      onCancel: () => this.onHandleCancel(),
      onReset: () => {}
    }
    const { bottom, left, width } = this.configBtn.nativeElement.getBoundingClientRect();
    const dialogWidth = 460;

    const ConfigureTableForManagePageComponent: any = CustomAvailableBudgetTableConfigDialogComponent;
    const dialogRef = this.dialog.open(ConfigureTableForManagePageComponent, {
      backdropClass: 'cdk-overlay-transparent-backdrop',
      panelClass: 'ceg-config-dialog',
      scrollStrategy: new NoopScrollStrategy(),
      autoFocus: false,
      data: dialogData,
      width: `${dialogWidth}px`,
      position: {
        top: `${bottom}px`,
        left: `1.8rem`
      }
    });

    dialogRef.backdropClick().pipe(takeUntil(this.destroy$)).subscribe(() => {
      dialogData.onCancel();
    });
  }
}
